import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Gift, MessageCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useConfig, whatsappHref } from "@/lib/config";

export default function DiwaliPopup() {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const cfg = useConfig();

  useEffect(() => {
    if (sessionStorage.getItem("diwali_popup_shown")) return;
    const onLeave = (e) => {
      if (e.clientY <= 0) trigger();
    };
    const timer = setTimeout(trigger, 25000);
    document.addEventListener("mouseleave", onLeave);
    function trigger() {
      if (sessionStorage.getItem("diwali_popup_shown")) return;
      sessionStorage.setItem("diwali_popup_shown", "1");
      setOpen(true);
    }
    return () => {
      document.removeEventListener("mouseleave", onLeave);
      clearTimeout(timer);
    };
  }, []);

  const claim = async () => {
    if (!name.trim() || phone.replace(/\D/g, "").length < 10) {
      toast.error("Please enter name and 10-digit phone");
      return;
    }
    try {
      await api.post("/leads", {
        name, phone, from_city: "-", to_city: "-", bhk: "-",
        notes: "Diwali Offer DIWALI10 claimed",
        source: "diwali_popup",
      });
      toast.success("Offer claimed! Code: DIWALI10 — we'll call in 5 min.");
      setOpen(false);
    } catch {
      toast.error("Please try WhatsApp instead");
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-md p-0 overflow-hidden" data-testid="diwali-popup">
        <div className="festive-shimmer p-4 text-center text-white">
          <Gift className="w-8 h-8 mx-auto mb-1" />
          <p className="font-display text-xs uppercase tracking-widest">Diwali Shifting Dhamaka</p>
        </div>
        <div className="p-6">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl text-[#0F172A]">Flat 10% OFF + Free Bubble Wrap</DialogTitle>
            <DialogDescription className="text-slate-600">
              Book before Diwali and save up to ₹4,000 on your shifting. Use code <span className="font-bold text-[#F97316]">DIWALI10</span>.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-3 mt-4">
            <Input placeholder="Your Name" value={name} onChange={(e) => setName(e.target.value)} data-testid="diwali-name-input" />
            <Input placeholder="Phone Number (10-digit)" value={phone} onChange={(e) => setPhone(e.target.value)} data-testid="diwali-phone-input" />
            <div className="grid grid-cols-2 gap-2">
              <Button onClick={claim} className="bg-[#F97316] hover:bg-[#EA580C] text-white" data-testid="diwali-popup-claim-button">
                Claim 10% Off
              </Button>
              <Button
                variant="outline"
                onClick={() => window.open(whatsappHref(cfg.whatsapp_number, "Hi! I want to claim DIWALI10 offer."), "_blank")}
                className="border-[#22C55E] text-[#22C55E] hover:bg-[#22C55E] hover:text-white"
                data-testid="diwali-popup-whatsapp-button"
              >
                <MessageCircle className="w-4 h-4 mr-1" /> WhatsApp
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
